import React, { useEffect, useState } from 'react';
import { Modal, Spin, Select, Descriptions, Input, Button, notification, Tooltip } from 'antd'
import { post } from '../../utils/http';
import api from '../../utils/api';
import { sessionManager } from '../../core/SessionManager';
import { EditOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons'
import moment from 'moment';

const { Option } = Select;
const { confirm } = Modal;
const { TextArea } = Input;
const { Item } = Descriptions;

export default function EditDetailInformation(props) {
        const [detailData, setDetailData] = useState({});
        const [isGetData, setIsGetData] = useState(false);
        const [replyMsg, setReplyMsg] = useState("");
        const [status, setStatus] = useState("");
        const [loading, setLoading] = useState(false);
        const [editStatus, setEditStatus] = useState(true);
        const [savedStatus, setSavedStatus] = useState("");

        useEffect(() => {
                if (!isGetData) {
                        getDetail();
                }
                // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [isGetData])

        const getDetail = () => {
                setLoading(true)
                const issueData = { issueId: props.editValue }
                post(api.queryReqDetail, issueData).then(function (response) {
                        setDetailData(response)
                        setIsGetData(true)
                        setStatus(response.status)
                        setSavedStatus(response.status)
                        setLoading(false)
                }).catch(function (error) {
                        console.log("@getDataError", error);
                        setLoading(false)
                        props.closeDialog("manualClose", false, replyMsg)
                        notification['error']({
                                message: 'Fail to get Data, the modal will close.',
                        });
                        setTimeout(()=>{
                                Modal.destroyAll();
                                props.closeEditModal();
                        },1500)

                })
        }

        const handleDateTime = (text) => {
                if (text != null && text !== '') {
                        var date = Date.parse(text);
                        var strDate = new Date(date);
                        strDate.setHours(strDate.getHours() + new Date().getTimezoneOffset() / -60);
                        return moment(strDate).format('YYYY-MM-DD HH:mm:ss');
                } else {
                        return '';
                }
              }

        const setStatusStyle = () => {
                if (editStatus) {
                        return <div style={{ width: "150px", display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ fontSize: 16 }}>{status}</div>
                                        <div>
                                                <Tooltip title="edit" placement="right">
                                                        <EditOutlined onClick={() => handleEditStatus("edit")} variant="contained" style={{ height: "20px", textAlign: "right", backgroundColor: "#f8f8f8", marginLeft: "50px", cursor: 'pointer' }} />
                                                </Tooltip>
                                        </div>
                                </div>

                } else {
                        return (<div style={{ width: "170px", display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                        <Select value={status} onChange={(value) => setStatus(value)}>
                                                <Option value='OPEN'>open</Option>
                                                {props.roleId === '2' && <Option value='PENDING'>Pending</Option>}
                                                <Option value='CLOSE'>close</Option>
                                        </Select>
                                </div>
                                <div style={{ display: 'flex', marginTop: "8px" }}>
                                        <Tooltip title="submit" placement="right">
                                                <CheckOutlined onClick={() => handleEditStatus("submit")} variant="contained" style={{ height: "20px", textAlign: "right", backgroundColor: "#f8f8f8", marginLeft: "50px", cursor: 'pointer' }} />
                                        </Tooltip>
                                        <Tooltip title="cancle" placement="right">
                                                <CloseOutlined onClick={() => handleEditStatus("cancle")} variant="contained" style={{ height: "20px", textAlign: "right", backgroundColor: "#f8f8f8", marginLeft: "15px", cursor: 'pointer' }} />
                                        </Tooltip>
                                </div></div>)
                }
        }

        const handleEditStatus = (flag) => {
                if (flag === "submit") {
                        setLoading(true)
                        var updateData = { id: props.editValue, status: status }
                        post(api.updateStatus, updateData).then(function (response) {
                                notification['success']({
                                        message: 'Update successfully.',
                                });
                                setSavedStatus(status)
                                setLoading(false)
                                props.handleSearch();
                        }).catch(function (error) {
                                setLoading(false);
                                setStatus(savedStatus);
                                notification['error']({
                                        message: 'Fail to update.',
                                });
                                console.log(error);
                        })
                } else if (flag === "cancle") {
                        setStatus(savedStatus)
                }

                setEditStatus(!editStatus);
        }

        const handleSubmit = () => {//submit button


                if (replyMsg === null || replyMsg === "") {
                        notification['error']({
                                message: 'Please input comment!',
                        });
                } else {

                        setLoading(true)

                        const createReply = {
                                issueId: props.editValue,
                                username: sessionManager.getMerchantName() || sessionManager.getUserInfo().userName,
                                replyContent: replyMsg
                        }
                        post(api.createReply, createReply).then(function (response) {

                                notification['success']({
                                        message: 'Reply successfully.',
                                });
                                setReplyMsg("");
                                getDetail();
                                setLoading(false)
                        }).catch(function (error) {
                                notification['error']({
                                        message: 'Fail to reply.',
                                });
                                console.log("@error", error)
                                setLoading(false)
                        })
                }
        }

        const handleCancle = () => {
                confirm({
                        content: "Are you sure to close this modal?",
                        onOk() {
                                Modal.destroyAll();
                                props.closeEditModal();
                        }
                });
        };


        return (
                <>
                        <Modal
                                footer={null}
                                title="Issue Info"
                                visible={props.isOpenEdit}
                                onOk={handleSubmit}
                                onCancel={handleCancle}
                                okText="Submit"
                                bodyStyle={{ height: '500px', overflow: 'auto' }}
                        >
                                <Spin spinning={loading}>
                                        {detailData !== {} && <Descriptions column={1} labelStyle={{ fontSize: 16, width: "35%" }} contentStyle={{ fontSize: 16 }}>
                                                <Item label="Service Category">{detailData.serviceCategory}</Item>
                                                <Item label="Service Type">{detailData.serviceType}</Item>
                                                <Item label="Date and Time">{handleDateTime(detailData.dateAndTime)}</Item>
                                                <Item label="Contact Number">{detailData.contactNumber}</Item>
                                                <Item label="Contact Email">{detailData.contactEmail}</Item>
                                                <Item label="Person In Charge">{detailData.personInCharge}</Item>
                                        </Descriptions>}
                                        
                                        <h4>Attachment:</h4>
                                        {detailData.attachments && 
                                          detailData.attachments.map((item, index) => {
                                                return <div key={index} style={{marginBottom:'5px'}}> <a href={item.serviceRequestAttachPath} target="blank"> {item.serviceRequestAttachName} </a> </div>
                                          })      
                                        }
                                        <hr style={{ margin: "20px 0" }} />
                                        <div style={{ width: "150px", display: "flex", fontSize: "16px", lineHeight: "30px" }}>
                                                <p style={{ fontSize: "16px" }}>Status:</p>
                                                <div>
                                                        {setStatusStyle()}
                                                </div>
                                        </div>

                                        <div style={{ backgroundColor: "#f5f5f5", padding: "10px", fontSize: "16px", marginTop: "20px" }}>
                                                <div>
                                                        <p>Reported by <span style={{ fontWeight: "bold" }}>{detailData && detailData.username} </span> on {detailData && handleDateTime(detailData.createionDate)}</p>
                                                        <p style={{ paddingLeft: "15px" }}>{detailData && detailData.content}</p>
                                                </div>
                                                {detailData && detailData.replyContent && detailData.replyContent.map((reply) => {
                                                        return (
                                                                <div>
                                                                        <hr />
                                                                        <p>Reported by <span style={{ fontWeight: "bold" }}>{reply.replyuser}</span> on {reply && handleDateTime(reply.replydate)}</p>
                                                                        <p style={{ paddingLeft: "15px" }}>{reply.replycontent}</p>
                                                                </div>
                                                        )
                                                })}
                                        </div>

                                        <div>
                                                <p style={{ fontSize: "18px", marginTop: "20px" }}>Service Request Comments</p>

                                                <TextArea value={replyMsg} name="reply" onChange={event => setReplyMsg(event.target.value)} style={{ backgroundColor: "#f5f5f5", height: "160px", padding: "10px", marginBottom: "20px", width: "100%" }} />
                                                <Button type="primary" htmlType="submit" onClick={handleSubmit}>reply</Button>
                                        </div>


                                </Spin>
                        </Modal>
                </>

        );
}
